import { getAllocationUtils } from './utils';
import sortByPrice from './sortByPrice';
import { agenciesInListingsGD } from './agenciesInListingsGD';
import { hourlyBannerGuest, hourlyBannerUser } from './hourlyBannerUserAndGuest';

const experiments = {
    sortByPrice,
    agenciesInListingsGD,
    hourlyBannerGuest,
    hourlyBannerUser,
};

export const clientExperiments = getAllocationUtils(experiments);
